import { render, staticRenderFns } from "./SelectWithInfinite.vue?vue&type=template&id=2f5cda65"
import script from "./SelectWithInfinite.vue?vue&type=script&lang=js"
export * from "./SelectWithInfinite.vue?vue&type=script&lang=js"
import style0 from "./SelectWithInfinite.vue?vue&type=style&index=0&id=2f5cda65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports